import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/home/ubuntu/download/69695302c9f2cb0014de4538/golfconnect/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download/69695302c9f2cb0014de4538/golfconnect/src/components/common/Header.tsx");
